import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-myImg",
  "use": "icon-myImg-usage",
  "viewBox": "0 0 12 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 11\" id=\"icon-myImg\">\r\n  <path id=\"icon-myImg_联合_123\" data-name=\"联合 123\" class=\"cls-1\" d=\"M3216,6161h-12v-11h12v11h0Zm-1.532-1-2.193-3.511-5.62,3.511Zm-9.467-.146,7.592-4.744,2.407,3.854V6151h-10Zm1-6.352a1.5,1.5,0,1,1,1.5,1.5A1.5,1.5,0,0,1,3206,6153.5Z\" transform=\"translate(-3204 -6150)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol